import { connect } from 'react-redux';
import { IStoreState } from 'src/store';
import { FrameworkActionCreator, RMTimesActionCreator, SpecsActionCreator, AppointmentActionCreator, AdditionalServicesActionCreator, MenusActionCreator, WebOpsActionCreator } from 'src/store/states';
import AddSkipServices from 'src/components/AddSkipServices/AddSkipServices';
import { BlankDeptSpec } from 'src/models/Specs/TestSpecs';

const mapStateToProps = (state: IStoreState) => ({
    specData: state.Specs.specs,
    apptVin: state.Appointment.ApptVeh.vin,
    apptCust: state.Appointment.ApptCust,
    inquiryInvoked: state.AdditionalServices.allServices.inquiryInvoked,
    showWeOwes: state.Specs.specs?.showWeOwes,
    showOEMRecall: state.Specs.specs?.showOEMRecall,
    showPrvRecom: state.Specs.specs?.showPrvRecom,
    specProfile: state.Framework.specProfile,
    additionalServices: state.AdditionalServices,
    specDeptData: state.Specs.deptSpecs !== undefined ? state.Specs.deptSpecs : BlankDeptSpec,
    specDefaultDept: state.Specs.specs !== undefined ? state.Specs.specs.departmentFlag : '',
    apptOps: state.Appointment.ApptOps,
    invalidDates: state.RMTimes.invalidDates,
    invalidDatesDept: state.RMTimes.invalidDatesDept,
    apptDept: state.Appointment.Appointment.department,
    vehicles: state.Vehicles.vehicles,
    selectedVehicle: state.Vehicles.selectedVehicle,
    theme: state.Framework.theme,
    menusReturnCode: state.Menus.allMenus.returnCode,
    lexusMCLaunched: state.Framework.lexusMCLaunched,
    toyotaMCLaunched: state.Framework.toyotaMCLaunched,
    locale: state.Framework.locale,
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    countryCode: state.Framework.dealerCountry,
    lexusTDMCLaunched: state.Framework.lexusTDMCLaunched,
    toyotaTDMCLaunched: state.Framework.toyotaTDMCLaunched,
});

const mapDispatchToProps = {
    pushToMainPanes: FrameworkActionCreator.pushToMainPane,
    getRMTimes: RMTimesActionCreator.GetRMTimes,
    getDeptSpecs: SpecsActionCreator.GetDeptSpecs,
    UpdateApptOps: AppointmentActionCreator.UpdateApptOps,
    determineDept: AppointmentActionCreator.DetermineDept,
    getInvalidDates: RMTimesActionCreator.GetInvalidDates,
    clearInvalidDates: RMTimesActionCreator.ClearInvalidDates,
    clearAdditionalChecks: AdditionalServicesActionCreator.ClearCheckedAdditionalServices,
    clearMenusChecks: MenusActionCreator.ClearMenusChecks,
    clearWebOpChecks: WebOpsActionCreator.ClearCheckedWebOps,
    addLogEntry: FrameworkActionCreator.addLogEntry,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(AddSkipServices);